/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	CreateOrganization400,
	CreateOrganization403,
	CreateOrganization500,
	DeleteOrganization400,
	DeleteOrganization403,
	DeleteOrganization404,
	DeleteOrganization500,
	GetMyOrganization500,
	GetMyOrganizationSettings200,
	GetMyOrganizationSettings500,
	GetOrganization400,
	GetOrganization403,
	GetOrganization404,
	GetOrganization500,
	ListOrganizations400,
	ListOrganizations403,
	ListOrganizations500,
	ListOrganizationsParams,
	Organization,
	OrganizationCreate,
	OrganizationUpdate,
	UpdateMyOrganizationPollTimes200,
	UpdateMyOrganizationPollTimes400,
	UpdateMyOrganizationPollTimes500,
	UpdateMyOrganizationPollTimesBody,
	UpdateMyOrganizationSettings200,
	UpdateMyOrganizationSettings400,
	UpdateMyOrganizationSettings500,
	UpdateMyOrganizationSettingsBody,
	UpdateOrganization400,
	UpdateOrganization403,
	UpdateOrganization404,
	UpdateOrganization500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListOrganizationsUrl = (params?: ListOrganizationsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/organizations?${stringifiedParams}`
		: `/organizations`;
};

/**
 * @summary List organizations with optional filters (admin only)
 */
export const listOrganizations = async (
	params?: ListOrganizationsParams,
	options?: RequestInit,
): Promise<Organization[]> => {
	return customFetch<Organization[]>(getListOrganizationsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListOrganizationsQueryKey = (
	params?: ListOrganizationsParams,
) => {
	return ["organizations", ...(params ? [params] : [])] as const;
};

export const getListOrganizationsQueryOptions = <
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListOrganizationsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listOrganizations>>
	> = ({ signal }) => listOrganizations(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listOrganizations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listOrganizations>>
>;
export type ListOrganizationsQueryError =
	| ListOrganizations400
	| ListOrganizations403
	| ListOrganizations500;

export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params: undefined | ListOrganizationsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizations>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizations>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List organizations with optional filters (admin only)
 */

export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListOrganizationsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List organizations with optional filters (admin only)
 */
export const useSetListOrganizationsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListOrganizationsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listOrganizations>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listOrganizations>> | undefined,
			  ) => Awaited<ReturnType<typeof listOrganizations>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listOrganizations>>>(
			{ queryKey: getListOrganizationsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary List organizations with optional filters (admin only)
 */
export const useGetListOrganizationsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListOrganizationsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listOrganizations>>>(
			getListOrganizationsQueryKey(params),
		);
};

export const getCreateOrganizationUrl = () => {
	return `/organizations`;
};

/**
 * @summary Create a new organization (admin only)
 */
export const createOrganization = async (
	organizationCreate: OrganizationCreate,
	options?: RequestInit,
): Promise<Organization> => {
	return customFetch<Organization>(getCreateOrganizationUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(organizationCreate),
	});
};

export const getCreateOrganizationMutationOptions = <
	TError =
		| CreateOrganization400
		| CreateOrganization403
		| CreateOrganization500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createOrganization>>,
		TError,
		{ data: OrganizationCreate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createOrganization>>,
	TError,
	{ data: OrganizationCreate },
	TContext
> => {
	const mutationKey = ["createOrganization"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createOrganization>>,
		{ data: OrganizationCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createOrganization(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = OrganizationCreate;
export type CreateOrganizationMutationError =
	| CreateOrganization400
	| CreateOrganization403
	| CreateOrganization500;

/**
 * @summary Create a new organization (admin only)
 */
export const useCreateOrganization = <
	TError =
		| CreateOrganization400
		| CreateOrganization403
		| CreateOrganization500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createOrganization>>,
			TError,
			{ data: OrganizationCreate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createOrganization>>,
	TError,
	{ data: OrganizationCreate },
	TContext
> => {
	return useMutation(
		getCreateOrganizationMutationOptions(options),
		queryClient,
	);
};
export const getGetMyOrganizationUrl = () => {
	return `/organizations/me`;
};

/**
 * @summary Get the authenticated user's own organization record
 */
export const getMyOrganization = async (
	options?: RequestInit,
): Promise<Organization> => {
	return customFetch<Organization>(getGetMyOrganizationUrl(), {
		...options,
		method: "GET",
	});
};

export const getGetMyOrganizationQueryKey = () => {
	return ["organizations", "me"] as const;
};

export const getGetMyOrganizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getMyOrganization>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetMyOrganizationQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getMyOrganization>>
	> = ({ signal }) => getMyOrganization({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getMyOrganization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyOrganizationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getMyOrganization>>
>;
export type GetMyOrganizationQueryError = GetMyOrganization500;

export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganization>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganization>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the authenticated user's own organization record
 */

export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetMyOrganizationQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the authenticated user's own organization record
 */
export const useSetGetMyOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof getMyOrganization>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getMyOrganization>> | undefined,
			  ) => Awaited<ReturnType<typeof getMyOrganization>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getMyOrganization>>>(
			{ queryKey: getGetMyOrganizationQueryKey() },
			updater,
		);
	};
};

/**
 * @summary Get the authenticated user's own organization record
 */
export const useGetGetMyOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getMyOrganization>>>(
			getGetMyOrganizationQueryKey(),
		);
};

export const getGetMyOrganizationSettingsUrl = () => {
	return `/organizations/me/settings`;
};

/**
 * @summary Get the authenticated user's application settings and preferences
 */
export const getMyOrganizationSettings = async (
	options?: RequestInit,
): Promise<GetMyOrganizationSettings200> => {
	return customFetch<GetMyOrganizationSettings200>(
		getGetMyOrganizationSettingsUrl(),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetMyOrganizationSettingsQueryKey = () => {
	return ["organizations", "me", "settings"] as const;
};

export const getGetMyOrganizationSettingsQueryOptions = <
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getMyOrganizationSettings>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetMyOrganizationSettingsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getMyOrganizationSettings>>
	> = ({ signal }) => getMyOrganizationSettings({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getMyOrganizationSettings>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyOrganizationSettingsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getMyOrganizationSettings>>
>;
export type GetMyOrganizationSettingsQueryError = GetMyOrganizationSettings500;

export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganizationSettings>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganizationSettings>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganizationSettings>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganizationSettings>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the authenticated user's application settings and preferences
 */

export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetMyOrganizationSettingsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the authenticated user's application settings and preferences
 */
export const useSetGetMyOrganizationSettingsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof getMyOrganizationSettings>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof getMyOrganizationSettings>>
						| undefined,
			  ) => Awaited<ReturnType<typeof getMyOrganizationSettings>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof getMyOrganizationSettings>>
		>({ queryKey: getGetMyOrganizationSettingsQueryKey() }, updater);
	};
};

/**
 * @summary Get the authenticated user's application settings and preferences
 */
export const useGetGetMyOrganizationSettingsQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof getMyOrganizationSettings>>
		>(getGetMyOrganizationSettingsQueryKey());
};

export const getUpdateMyOrganizationSettingsUrl = () => {
	return `/organizations/me/settings`;
};

/**
 * @summary Update the authenticated user's application settings and preferences
 */
export const updateMyOrganizationSettings = async (
	updateMyOrganizationSettingsBody: UpdateMyOrganizationSettingsBody,
	options?: RequestInit,
): Promise<UpdateMyOrganizationSettings200> => {
	return customFetch<UpdateMyOrganizationSettings200>(
		getUpdateMyOrganizationSettingsUrl(),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(updateMyOrganizationSettingsBody),
		},
	);
};

export const getUpdateMyOrganizationSettingsMutationOptions = <
	TError = UpdateMyOrganizationSettings400 | UpdateMyOrganizationSettings500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
		TError,
		{ data: UpdateMyOrganizationSettingsBody },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
	TError,
	{ data: UpdateMyOrganizationSettingsBody },
	TContext
> => {
	const mutationKey = ["updateMyOrganizationSettings"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
		{ data: UpdateMyOrganizationSettingsBody }
	> = (props) => {
		const { data } = props ?? {};

		return updateMyOrganizationSettings(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMyOrganizationSettingsMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMyOrganizationSettings>>
>;
export type UpdateMyOrganizationSettingsMutationBody =
	UpdateMyOrganizationSettingsBody;
export type UpdateMyOrganizationSettingsMutationError =
	| UpdateMyOrganizationSettings400
	| UpdateMyOrganizationSettings500;

/**
 * @summary Update the authenticated user's application settings and preferences
 */
export const useUpdateMyOrganizationSettings = <
	TError = UpdateMyOrganizationSettings400 | UpdateMyOrganizationSettings500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
			TError,
			{ data: UpdateMyOrganizationSettingsBody },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
	TError,
	{ data: UpdateMyOrganizationSettingsBody },
	TContext
> => {
	return useMutation(
		getUpdateMyOrganizationSettingsMutationOptions(options),
		queryClient,
	);
};
export const getUpdateMyOrganizationPollTimesUrl = () => {
	return `/organizations/me/poll-times`;
};

/**
 * @summary Update the authenticated user's device polling intervals
 */
export const updateMyOrganizationPollTimes = async (
	updateMyOrganizationPollTimesBody: UpdateMyOrganizationPollTimesBody,
	options?: RequestInit,
): Promise<UpdateMyOrganizationPollTimes200> => {
	return customFetch<UpdateMyOrganizationPollTimes200>(
		getUpdateMyOrganizationPollTimesUrl(),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(updateMyOrganizationPollTimesBody),
		},
	);
};

export const getUpdateMyOrganizationPollTimesMutationOptions = <
	TError = UpdateMyOrganizationPollTimes400 | UpdateMyOrganizationPollTimes500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
		TError,
		{ data: UpdateMyOrganizationPollTimesBody },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
	TError,
	{ data: UpdateMyOrganizationPollTimesBody },
	TContext
> => {
	const mutationKey = ["updateMyOrganizationPollTimes"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
		{ data: UpdateMyOrganizationPollTimesBody }
	> = (props) => {
		const { data } = props ?? {};

		return updateMyOrganizationPollTimes(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMyOrganizationPollTimesMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>
>;
export type UpdateMyOrganizationPollTimesMutationBody =
	UpdateMyOrganizationPollTimesBody;
export type UpdateMyOrganizationPollTimesMutationError =
	| UpdateMyOrganizationPollTimes400
	| UpdateMyOrganizationPollTimes500;

/**
 * @summary Update the authenticated user's device polling intervals
 */
export const useUpdateMyOrganizationPollTimes = <
	TError = UpdateMyOrganizationPollTimes400 | UpdateMyOrganizationPollTimes500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
			TError,
			{ data: UpdateMyOrganizationPollTimesBody },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
	TError,
	{ data: UpdateMyOrganizationPollTimesBody },
	TContext
> => {
	return useMutation(
		getUpdateMyOrganizationPollTimesMutationOptions(options),
		queryClient,
	);
};
export const getGetOrganizationUrl = (orgId: string) => {
	return `/organizations/${orgId}`;
};

/**
 * @summary Get a single organization by OrgId (admin only)
 */
export const getOrganization = async (
	orgId: string,
	options?: RequestInit,
): Promise<Organization> => {
	return customFetch<Organization>(getGetOrganizationUrl(orgId), {
		...options,
		method: "GET",
	});
};

export const getGetOrganizationQueryKey = (orgId: string) => {
	return ["organizations", orgId] as const;
};

export const getGetOrganizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetOrganizationQueryKey(orgId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
		signal,
	}) => getOrganization(orgId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: orgId !== null && orgId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getOrganization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError =
	| GetOrganization400
	| GetOrganization403
	| GetOrganization404
	| GetOrganization500;

export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getOrganization>>,
					TError,
					Awaited<ReturnType<typeof getOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getOrganization>>,
					TError,
					Awaited<ReturnType<typeof getOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single organization by OrgId (admin only)
 */

export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetOrganizationQueryOptions(orgId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single organization by OrgId (admin only)
 */
export const useSetGetOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return (
		orgId: string,
		updater:
			| Awaited<ReturnType<typeof getOrganization>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getOrganization>> | undefined,
			  ) => Awaited<ReturnType<typeof getOrganization>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getOrganization>>>(
			{ queryKey: getGetOrganizationQueryKey(orgId) },
			updater,
		);
	};
};

/**
 * @summary Get a single organization by OrgId (admin only)
 */
export const useGetGetOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return (orgId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getOrganization>>>(
			getGetOrganizationQueryKey(orgId),
		);
};

export const getUpdateOrganizationUrl = (orgId: string) => {
	return `/organizations/${orgId}`;
};

/**
 * @summary Update an existing organization (admin only)
 */
export const updateOrganization = async (
	orgId: string,
	organizationUpdate: OrganizationUpdate,
	options?: RequestInit,
): Promise<Organization> => {
	return customFetch<Organization>(getUpdateOrganizationUrl(orgId), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(organizationUpdate),
	});
};

export const getUpdateOrganizationMutationOptions = <
	TError =
		| UpdateOrganization400
		| UpdateOrganization403
		| UpdateOrganization404
		| UpdateOrganization500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOrganization>>,
		TError,
		{ orgId: string; data: OrganizationUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateOrganization>>,
	TError,
	{ orgId: string; data: OrganizationUpdate },
	TContext
> => {
	const mutationKey = ["updateOrganization"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateOrganization>>,
		{ orgId: string; data: OrganizationUpdate }
	> = (props) => {
		const { orgId, data } = props ?? {};

		return updateOrganization(orgId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = OrganizationUpdate;
export type UpdateOrganizationMutationError =
	| UpdateOrganization400
	| UpdateOrganization403
	| UpdateOrganization404
	| UpdateOrganization500;

/**
 * @summary Update an existing organization (admin only)
 */
export const useUpdateOrganization = <
	TError =
		| UpdateOrganization400
		| UpdateOrganization403
		| UpdateOrganization404
		| UpdateOrganization500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateOrganization>>,
			TError,
			{ orgId: string; data: OrganizationUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateOrganization>>,
	TError,
	{ orgId: string; data: OrganizationUpdate },
	TContext
> => {
	return useMutation(
		getUpdateOrganizationMutationOptions(options),
		queryClient,
	);
};
export const getDeleteOrganizationUrl = (orgId: string) => {
	return `/organizations/${orgId}`;
};

/**
 * @summary Soft-delete an organization by ID (admin only)
 */
export const deleteOrganization = async (
	orgId: string,
	options?: RequestInit,
): Promise<Organization> => {
	return customFetch<Organization>(getDeleteOrganizationUrl(orgId), {
		...options,
		method: "DELETE",
	});
};

export const getDeleteOrganizationMutationOptions = <
	TError =
		| DeleteOrganization400
		| DeleteOrganization403
		| DeleteOrganization404
		| DeleteOrganization500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteOrganization>>,
		TError,
		{ orgId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteOrganization>>,
	TError,
	{ orgId: string },
	TContext
> => {
	const mutationKey = ["deleteOrganization"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteOrganization>>,
		{ orgId: string }
	> = (props) => {
		const { orgId } = props ?? {};

		return deleteOrganization(orgId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteOrganization>>
>;

export type DeleteOrganizationMutationError =
	| DeleteOrganization400
	| DeleteOrganization403
	| DeleteOrganization404
	| DeleteOrganization500;

/**
 * @summary Soft-delete an organization by ID (admin only)
 */
export const useDeleteOrganization = <
	TError =
		| DeleteOrganization400
		| DeleteOrganization403
		| DeleteOrganization404
		| DeleteOrganization500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteOrganization>>,
			TError,
			{ orgId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteOrganization>>,
	TError,
	{ orgId: string },
	TContext
> => {
	return useMutation(
		getDeleteOrganizationMutationOptions(options),
		queryClient,
	);
};
